import { render, staticRenderFns } from "./PanelCompetitionScannerQR.vue?vue&type=template&id=671cc293&scoped=true&"
import script from "./PanelCompetitionScannerQR.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionScannerQR.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionScannerQR.vue?vue&type=style&index=0&id=671cc293&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671cc293",
  null
  
)

export default component.exports